import { useState } from 'react';

export default function useDirtyFormFields(): { dirty: boolean; markAsDirty: () => void } {
  const [dirty, setDirty] = useState(false);
  const markAsDirty = (): void => setDirty(true);
  return { dirty, markAsDirty } as const;
}
